import { useMemo } from 'react';
import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { useSelector } from 'react-redux';
import { useAvailableContacts } from './useAvailableContacts';
import { selectPromoInfo } from '../../../selectors/promoInfo';

type TComponentPromo = IPromoModalProps['promo'];
type TComponentFeatures = IPromoModalProps['promo']['features'];
type TComponentLabels = IPromoModalProps['promo']['labels'];

export const usePreparedPromo = (): TComponentPromo | null => {
  const promo = useSelector(selectPromoInfo);
  const contacts = useAvailableContacts();

  return useMemo(() => {
    if (!promo) {
      return null;
    }

    const isMultipleContacts = contacts.sellers.length + contacts.builders.length > 1;

    const title = isMultipleContacts ? '' : `${promo.isFromBuilder ? 'Застройщик' : ''} ${promo.authorName}`.trim();

    return {
      authorName: title,
      authorLogo: isMultipleContacts ? undefined : (promo.authorLogoUrl as string),
      name: promo.name,
      type: promo.promoType,
      features: (promo.features as TComponentFeatures) || [],
      banks: promo.banks.map(bank => ({
        id: bank.id,
        name: bank.name,
        logoUrl: bank.secondSquareImageUrl || bank.logoUrl || undefined,
      })),
      cianMortgageBank: promo.bank && {
        id: promo.bank.id,
        name: promo.bank.name,
        logoUrl: promo.bank.secondSquareImageUrl || promo.bank.logoUrl || undefined,
        isPartner: promo.bank.isPartner,
      },
      description: promo.description,
      availableJks: promo.availableJks,
      labels: (promo.dialogLabels as TComponentLabels) || [],
      availablePurchaseTerms: promo.availablePurchaseTerms || [],
      mortgageLegalInfo: promo.promoLegalTerms ?? undefined,
    };
  }, [promo, contacts]);
};
